export const boxShadows = {
    snackbar: '0 9px 20px 0 rgba(74, 97, 135, 0.2)',
};
